<template>
  <div class="loginPageClass">

    <div style="width: 100%;height: 100%;display: flex">
      <div style="margin: auto">

        <el-row>
          <el-col :span="24">
            <div class="loginPage">
              <div class="Bosch_title">
                点春官网后台管理
              </div>
              <div>
                <el-input style="width: 420px;padding-left: 36px;" type="text"
                          v-model="loginForm.name"
                          placeholder="User">
                  <i class="el-icon-circle-close-outline el-input__icon" slot="suffix"
                     style="margin-right: 20px;" @click="clearUser">
                  </i>
                </el-input>
              </div>
              <el-input style="width: 420px;padding-left: 36px" :type="inputType"
                        v-model="loginForm.password"
                        placeholder="Password" @keyup.enter.native="login">
                <i :class="passIconType" slot="suffix" style="margin-right: 20px;"
                   @click="showOrHidePassword"> </i>
              </el-input>
              <button class="loginBtn" @click="login"> 登录</button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>


    <div style="position: absolute;bottom: 30px;right: 2%">
    </div>

    <footer class="bosch-footer">
    </footer>
  </div>

</template>
<script>
import ElCol from 'element-ui/packages/col/src/col';
import { loginUser } from '../../api/login';

async function login() {
  if (this.loginForm.name === '') {
    this.$message('请输入用户名');
  } else if (this.loginForm.password === '') {
    this.$message('请输入密码');
  } else {
    console.log('klsdks', this.loginForm);
    const result = await loginUser(this.loginForm);
    if (result.code === 1200) {
      console.log('wwwwww', result.data.user);
      if (result.data.user !== null) {
        // 用户信息存在cookie或者localstorage中
        const userInfoJsonStr = JSON.stringify(result.data.user);
        localStorage.setItem('loginUser', userInfoJsonStr);
        this.$router.push({
          path: '/tab',
          /* query: {
               user:result.data.user
             }, */
        });
      }
    } else {
      this.$message('用户名或密码错误！');
    }
  }
}

function showOrHidePassword() {
  if (this.inputType === 'password') {
    this.inputType = 'text';
    this.passIconType = 'el-icon-view el-input__icon';
  } else {
    this.inputType = 'password';
    this.passIconType = 'el-icon-view el-input__icon';
  }
}

function clearUser() {
  this.loginForm.name = '';
}

export default {
  name: 'login',
  data() {
    return {
      inputType: 'password',
      passIconType: 'el-icon-view el-input__icon',
      loginForm: {
        name: '',
        password: '',
      },
    };
  },
  methods: {
    login,
    showOrHidePassword,
    clearUser,
  },
  mounted() {

  },
  created() {

  },
};
</script>

<style>

  .loginPageClass {
    height: 100%;
    width: 100%;
    display: flex;
    background-color: rgb(205, 219, 238);
    background-size: 100% 100%;
    position: fixed;

  }

  .bosch-footer {
    background-size: 3000px auto;
    padding-top: 12px;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .login {
    /*margin: auto;*/
    /*background: url("../assets/login/login_background.jpg") no-repeat;*/
    /*background-size: cover;*/
    /*height: 100%;*/
    /*width: 100%;*/
  }

  .loginPage {
    width: 496px;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 6px;
  }

  .loginPage .el-input {

    padding: 15px;
  }

  .loginPage .el-input__inner {
    height: 52px;
    border: 1px solid #AEAEAE;
    font-size: 16px;
  }

  .loginPage .el-input__icon {
    font-size: 20px;
  }

  /*记住密码字体颜色 选中时*/
  .loginPage .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #0B0C0C;

  }

  /*记住密码选择方框 选中时*/
  .loginPage .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #005691;
    border-color: #005691;
  }

  /*.loginPage .el-checkbox__inner:hover {*/
  /*border-color: #dcdfe6;*/
  /*}*/

  /*记住密码选择方框大小*/
  .loginPage .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /*记住密码字体大小*/
  .loginPage .el-checkbox__label {
    font-size: 16px;
  }

  /*记住密码选择方框 图标位置*/
  .loginPage .el-checkbox__inner::after {
    left: 7px;
    top: 4px;
  }

  .Bosch_title {
    height: 90px;
    font-size: 24px;
    color: #000;
    text-align: center;
    line-height: 100px;
  }

  .loginBtn {
    width: 420px;
    height: 52px;
    margin-left: 36px;
    margin-top: 20px;
    border-radius: 2px;
    font-size: 20px;
    color: #fff;
    background-color: #005691;
    border: 1px solid #005691;
  }

  .loginBtn:hover {
    cursor: pointer;
  }
</style>
